import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { withRouter } from "react-router";
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import 'bootstrap-select';
import '../css/ion.rangeSlider.css';
import $ from 'jquery';
import SearchCarNumber from './kasco_search_forms/SearchCarNumber';
import CarForm from './kasco_search_forms/CarForm';
import DriverForm from './kasco_search_forms/DriverForm';
import { store } from '../store';
import { fetchAutoMarks } from '../actions/autoMarksActions';
import { fetchAutoModels } from '../actions/autoModelsActions';
import { fetchAutoFuels } from '../actions/autoFuelActions';
import { fetchAutoTransmissions } from '../actions/autoTransmissionsActions';
import { fetchRegions } from '../actions/regionsActions';
import { fetchCities } from '../actions/citiesActions';
import { KaskoService } from '../services/kaskoService';
import ErrorIndicator from './ErrorIndicator';
import ErrorBanner from './banners/ErrorBanner';

class InsuranceSearchForm extends Component {
  state = {
    focused: false,
    step: 1,
    searchNumber: '',
    loading: false,
    hasError: false,
    forget: false,
    notFound: false,
    marketPrice: '',
    marketPriceUah: '',
    clientPrice: '',
    carPriceChecked: false,
    years: ['2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021'],
    carsData: {
      car_name: '',
      car_model: '',
      car_year: '',
      car_fuel: '',
      car_trans: '',
      car_engine: '',
      car_distance: '',
      car_number: '',
      region: '',
      city: ''
    },
    additionalData: {
      driversCont: 1,
      age: '18-25',
      experience: '1',
      taxi: false,
      credit: false
    }
  };
  searchCarNumberFormRef = React.createRef();

  componentDidMount() {
    store.dispatch(fetchAutoMarks());
    store.dispatch(fetchAutoFuels());
    store.dispatch(fetchAutoTransmissions());
    store.dispatch(fetchRegions());

    // setTimeout(() => {
      this.setQuery();
      // this.initRange();
      this.selSelectValues();
      this.getCarNumberFromQuery();
    // }, 100);

    $('select').selectpicker('refresh');
    $('#main').removeClass('ov-hidden');
  }

  componentDidUpdate(prevProps, prevState) {
    const { marketPrice } = this.state;

    $('select').selectpicker('refresh');

    if (prevState.marketPrice !== marketPrice) {
      this.pushQuery()
    }
  }

  getCarNumberFromQuery = () => {
    const { step } = this.state;
    const { number } = queryString.parse(this.props.location.search);

    if (number && step === 1) {
      this.setState(() => {
        return {
          searchNumber: number
        };
      }, this.triggerSubmitSearchCarNumberForm);
    }
  }

  getCarNumberFormRef = (ref) => {
    this.searchCarNumberFormRef = ref;
  }

  triggerSubmitSearchCarNumberForm = () => {
    if (this.searchCarNumberFormRef && this.state.step === 1) {
      this.searchCarNumberFormRef.dispatchEvent(new Event("submit"));
    }
  }

  focusInput = () => {
    this.setState({ focused: true })
  };

  blurInput = () => {
    this.setState({ focused: false })
  };

  selSelectValues = () => {
    $('select[name=car_name]').val(this.state.carsData.car_name);
    $('select[name=car_year]').val(this.state.carsData.car_year);
    $('select[name=car_fuel]').val(this.state.carsData.car_fuel);
    $('select[name=car_trans]').val(this.state.carsData.car_trans);
    $('select[name=region]').val(this.state.carsData.region);
    $('select[name=city]').val(this.state.carsData.city);
    $('select[name=age]').val(this.state.additionalData.age);
    $('select[name=experience]').val(this.state.additionalData.experience);
    $('select').selectpicker('refresh');
  };

  // initRange = () => {
  //   // range-volume
  //   const $range_volume = $('#range-volume');
  //   let min = 0.5;
  //   let max = 10;
  //   $range_volume.ionRangeSlider({
  //     hide_min_max: true,
  //     grid: true,
  //     type: 'single',
  //     min,
  //     max,
  //     from: this.state.carsData.car_engine !== '' ? parseFloat(this.state.carsData.car_engine) : 0,
  //     step: 0.1,
  //     // postfix: ' л',
  //     onChange: () => {
  //       this.setState({
  //         ...this.state,
  //         carsData: {
  //           ...this.state.carsData,
  //           car_engine: $('.range-engine .irs-single').text().match(/\d+/g).toString().replace(/,/g, '.')
  //         }
  //       });
  //       setTimeout(() => this.pushQuery('noRequest'), 100)
  //     },
  //   });
  //
  //   // range-milage
  //   let $range_milage = $('#range-milage');
  //   min = 0;
  //   max = 500;
  //   $range_milage.ionRangeSlider({
  //     hide_min_max: true,
  //     grid: true,
  //     type: 'single',
  //     min,
  //     max,
  //     from: this.state.carsData.car_distance !== '' ? parseFloat(this.state.carsData.car_distance) : 0,
  //     // postfix: ' тыс. км.',
  //     onChange: () => {
  //       this.setState({
  //         ...this.state,
  //         carsData: {
  //           ...this.state.carsData,
  //           car_distance: $('.range-distance .irs-single').text().match(/\d+/g).join('')
  //         }
  //       });
  //       setTimeout(() => this.pushQuery(), 100)
  //     },
  //   });
  // };

  clearRange = () => {
    const engine = $('#range-volume').data('ionRangeSlider');
    engine.update({ from: 0 });

    const milage = $('#range-milage').data('ionRangeSlider');
    milage.update({ from: 0 })
  };

  // обновить данные объема двигателя
  updateCarEngineVal = () => {
    const { car_engine } = this.state.carsData;
    const $engine = $('#range-volume').data('ionRangeSlider');
    $engine.update({
      from: car_engine
    });
  }

  setQuery = () => {
    const values = queryString.parse(this.props.location.search);
    this.getCarPrice(values.car, values.model, values.year, values.fuel, values.transmission, values.distance, values.region, values.city);

    if (values.car) store.dispatch(fetchAutoModels(values.car));
    if (values.region) store.dispatch(fetchCities(values.region));

    this.setState({
      step: parseInt(values.step ? values.step : 1),
      clientPrice: values.price ? values.price : '',
      carPriceChecked: values.price ? true : false,
      carsData: {
        car_name: values.car ? values.car : '',
        car_model: values.model ? values.model : '',
        car_year: values.year ? values.year : '',
        car_fuel: values.fuel ? values.fuel : '',
        car_trans: values.transmission ? values.transmission : '',
        car_engine: values.engine ? values.engine : '',
        car_distance: values.distance ? values.distance : '',
        car_number: values.number ? values.number : '',
        region: values.region ? values.region : '',
        city: values.city ? values.city : '',
      },
      additionalData: {
        driversCont: values.drivers ? parseInt(values.drivers) : 1,
        age: values.age ? values.age : '18-25',
        experience: values.experience ? values.experience : '1',
        taxi: values.taxi ? values.taxi : false,
        credit: values.credit ? values.credit : false
      }
    });
  };

  pushQuery = (request) => {
    const {
      step,
      marketPrice,
      clientPrice,
      carPriceChecked,
      carsData: {
        car_name,
        car_model,
        car_year,
        car_fuel,
        car_trans,
        car_distance,
        region,
        city,
        car_engine,
        car_number
      },
      additionalData: {
        driversCont,
        age,
        experience,
        taxi,
        credit }
    } = this.state;

    if (request !== 'noRequest') {
      this.getCarPrice(car_name, car_model, car_year, car_fuel, car_trans, car_distance, region, city);
    }

    let _step = `?step=${step}`;
    let car = car_name !== '' ? `&car=${car_name}` : '';
    let model = car_model !== '' && car_model !== undefined ? `&model=${car_model}` : '';
    let year = car_year !== '' && car_year !== undefined ? `&year=${car_year}` : '';
    let fuel = car_fuel !== '' && car_fuel !== undefined ? `&fuel=${car_fuel}` : '';
    let trans = car_trans !== '' && car_trans !== undefined ? `&transmission=${car_trans}` : '';
    let _region = region !== '' && region !== undefined ? `&region=${region}` : '';
    let _city = city !== '' && city !== undefined ? `&city=${city}` : '';
    let engine = car_engine !== '' && car_engine !== undefined ? `&engine=${car_engine}` : '';
    let distance = car_distance !== '' && car_distance !== undefined ? `&distance=${car_distance}` : '';
    let number = car_number !== '' && car_number !== undefined ? `&number=${car_number}` : '';
    let price = carPriceChecked ? clientPrice ? `&price=${clientPrice}` : '' : marketPrice ? `&price=${marketPrice}` : '';
    let drivers = driversCont !== '' && driversCont !== undefined ? `&drivers=${driversCont}` : '';
    let _age = age !== '' && age !== undefined ? `&age=${age}` : '';
    let _experience = experience !== '' && experience !== undefined ? `&experience=${experience}` : '';
    let _taxi = `&taxi=${taxi}`;
    let _credit = `&credit=${credit}`;

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: _step + car + model + year + fuel + trans + _region + _city + engine + distance + number + price + drivers + _age + _experience + _taxi + _credit
    });
  };

  getCarPrice = (car, model, year, fuel, trans, distance, region, city) => {
    if (!car || !model || !year || !fuel || !trans || !distance || !region || !city) return false;

    const options = {
      markId: car,
      modelId: model,
      years: year,
      fuelId: fuel,
      gearBoxId: trans,
      mileage: distance,
      stateId: region,
      cityId: city,
    };

    const { getCarPrice } = new KaskoService();
    this.setState({ isLoadingMarketPrice: true });

    getCarPrice(options).then(res => {
      const marketPrice = Math.floor(res.data.carAveragePriceUsd);
      const marketPriceUah = Math.floor(res.data.carAveragePriceUah);
      this.setState({
        marketPrice,
        marketPriceUah,
        isLoadingMarketPrice: false
      })
    });
  };

  prevStep = () => {
    if (this.state.step > 2) {
      this.setState(({ step }) => {
        return {
          step: step - 1,
        }
      });
      const destination = $('#kasco').offset().top;
      $('html, body').animate({ scrollTop: destination }, 1000);
      setTimeout(() => this.pushQuery(), 100)
    } else {
      this.setState({
        focused: false,
        step: 1,
        searchNumber: '',
        loading: false,
        hasError: false,
        forget: false,
        notFound: false,
        marketPrice: '',
        marketPriceUah: '',
        clientPrice: '',
        carPriceChecked: false,
        years: ['2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021'],
        carsData: {
          car_name: '',
          car_model: '',
          car_year: '',
          car_fuel: '',
          car_trans: '',
          car_engine: '',
          car_distance: '',
          car_number: '',
          region: '',
          city: ''
        },
        additionalData: {
          driversCont: 1,
          age: '18-25',
          experience: '1',
          taxi: false,
          credit: false
        }
      });

      // this.clearRange();
      this.props.history.push(this.props.location.pathname);
      window.scrollTo(0, 0);
      return <Redirect to={this.props.location.pathname} />
    }

    this.pushQuery();
    window.scrollTo(0, 0);
  };

  nextStep = () => {
    this.setState(({ step }) => {
      return {
        step: step + 1,
      }
    });
    setTimeout(() => this.pushQuery(), 100);
    window.scrollTo(0, 0);
  };

  // Search by number handels
  handleChange = (e) => {
    this.setState({ searchNumber: e.target.value.toUpperCase() })
  };

  // change car number
  handleChangeCarNumber = (e) => {
    this.setState({
      ...this.state,
      carsData: {
        ...this.state.carsData,
        car_number: e.target.value.toUpperCase()
      }
    });
    setTimeout(() => this.pushQuery('noRequest'), 100)
  };

  transformCarEngineVolume = (val) => {
    const valStr = val.toString();

    if (valStr.includes('.')) {
      return valStr;
    } else {
      return parseInt(valStr) / 1000;
    }
  }

  findByNumber = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const { getAutoDataByNumber, getAutoModels } = new KaskoService();
    const { searchNumber, years } = this.state;
    console.log('searchNumber ===>', searchNumber);

    getAutoDataByNumber(searchNumber)
      .then(res => {
        const carInfo = res.data;
        const car = JSON.parse(localStorage.getItem('autoMarks')).find((item) => item.name.toLowerCase() === res.data.carBrand.toLowerCase());

        getAutoModels(car.value).then(res => {
          store.dispatch(fetchAutoModels(car.value));
          localStorage.setItem('autoModels', JSON.stringify(res.data));
          const model = res.data.find((item) => item.name.toLowerCase() === carInfo.carModel.toLowerCase());
          const year = years.filter((item) => item === String(carInfo.carYearProduction)).join('');

          this.setState({
            ...this.state,
            carsData: {
              car_name: car.value,
              car_model: model ? model.value : '',
              car_year: year,
              car_fuel: '',
              car_trans: '',
              car_distance: '',
              region: '',
              city: '',
              car_number: searchNumber,
              car_engine: ((Math.floor(carInfo.engineCapacity * 100)) / 100000).toFixed(1)
            }
          });

          setTimeout(() => {
            this.setState({ loading: false });
            this.nextStep();

            const destination = $('#kasco').offset().top;
            $('html, body').animate({ scrollTop: destination }, 1000);
          }, 2000);
        })
      })
      .catch(() => {
        this.setState({
          ...this.state,
          notFound: true,
          carsData: {
            car_name: '',
            car_model: '',
            car_year: '',
            car_fuel: '',
            car_trans: '',
            car_distance: '',
            region: '',
            city: '',
            car_number: ''
          }
        });

        setTimeout(() => {
          this.setState({ loading: false });
          this.nextStep();

          const destination = $('#kasco').offset().top;
          $('html, body').animate({ scrollTop: destination }, 1000);
        }, 2000);
      });

    // setTimeout(() => {
    //   this.setState({ loading: false });
    //   this.nextStep();
    //
    //   const destination = $('#kasco').offset().top;
    //   $('html, body').animate({ scrollTop: destination }, 1000);
    // }, 2000);
  };

  checkBoxChange = () => {
    this.setState(({ carPriceChecked }) => {
      return {
        carPriceChecked: !carPriceChecked
      }
    });
    setTimeout(() => this.pushQuery('noRequest'), 100)
  };

  handleChangeMarketPrice = (event) => {
    event.persist();
    this.setState((prevState) => {
      return {
        clientPrice: event.target.value,
        carPriceChecked: true
      }
    });

    setTimeout(() => this.pushQuery('noRequest'), 100);
  };

  handleInputs = (event) => {
    if (event.target.name === 'car_name') {
      store.dispatch(fetchAutoModels(event.target.value));
      this.setState({
        ...this.state,
        carsData: {
          ...this.state.carsData,
          [event.target.name]: event.target.value,
          car_model: ''
        }
      });
    } else if (event.target.name === 'region') {
      this.setState({
        ...this.state,
        carsData: {
          ...this.state.carsData,
          [event.target.name]: event.target.value,
          city: ''
        }
      });
      store.dispatch(fetchCities(event.target.value));
    } else {
      this.setState({
        ...this.state,
        carsData: {
          ...this.state.carsData,
          [event.target.name]: event.target.value
        }
      })
    }
    setTimeout(() => this.pushQuery(), 100);
  };

  sendCarInfo = () => {
    const values = queryString.parse(this.props.location.search);
    // e.preventDefault();
    const { car_name, car_model, car_year, car_fuel, car_trans, car_distance, region, city } = this.state.carsData;

    this.setState({ loading: true, clientPrice: values.price });
    setTimeout(() => {
      if (car_name !== '' && car_model !== '' && car_year > 2008 && car_fuel !== '' && car_trans !== '' && car_distance !== '' && region !== '' && city !== '' && this.state.clientPrice > 0 && this.state.clientPrice <= 10000000) {
        this.scrollToForm();
        this.setState({ loading: false, hasError: false });
      } else {
        this.setState({ loading: false, hasError: true });
      }
    }, 0);
  };

  // Calculation form hendlers and functions
  setDriversCount = (event) => {
    this.setState({
      ...this.state,
      additionalData: {
        ...this.state.additionalData,
        driversCont: parseInt(event.target.value)
      }
    });
    setTimeout(() => this.pushQuery(), 100);
  };

  handleAdditionalInputs = (event) => {
    this.setState({
      ...this.state,
      additionalData: {
        ...this.state.additionalData,
        [event.target.name]: event.target.value
      }
    });
    setTimeout(() => this.pushQuery(), 100);
  };

  sendAdditionalInfo = () => {
    // e.preventDefault();

    const { clientPrice, carsData: { car_name, car_model, car_year, car_fuel, car_trans, car_distance, car_number, region, city }, additionalData: { driversCont, experience, age, credit, taxi } } = this.state;

    this.setState({ loading: true });
    localStorage.removeItem('offers');
    console.log('offers are cleared');

    setTimeout(() => {
      const options = {
        markId: car_name,
        modelId: car_model,
        years: car_year,
        fuelId: car_fuel,
        gearBoxId: car_trans,
        mileage: car_distance,
        stateId: region,
        cityId: city,
        carNumber: car_number ? car_number : '',
        carPrice: clientPrice,
        peopleCount: driversCont,
        minDriverStaj: experience,
        minDriverAge: age,
        isCredit: credit,
        isTaxi: taxi,
        locale: this.props.locale,
      };

      localStorage.setItem('carOptions', JSON.stringify(options));

      const { getOffers } = new KaskoService();
      getOffers(options)
        .then((res) => {
          localStorage.setItem('offers', JSON.stringify(res.data));
          this.setState({ loading: false, hasError: false });
          this.props.cleanCompare();
          this.props.history.push({
            pathname: this.props.locale === 'ua' ? '/uk/kasko/list' : '/kasko/list',
            search: this.props.location.search
          });
        })
        .catch((error) => {
          console.log('err ==>>>', error);
        });
    }, 1000);
  };

  scrollToForm = () => {
    this.nextStep();
    const destination = $('#kasco').offset().top;
    $('html, body').animate({ scrollTop: destination }, 1000);
  };

  render() {
    const { autoMarks, autoModels, autoFuels, autoTransmissions, regions, cities } = this.props;

    const strings = new LocalizedStrings({
      ru: {
        title1: 'Определите рыночную цену',
        title2: 'автомобиля по гос. номеру',
        titleTxt: 'Для зарегистрированных в Украине',
        needed: 'Обязательное поле',
        btn1: 'Оценить стоимость',
        forget: 'Не помню гос. номер',
        title3: 'Расчет стоимости КАСКО',
        notFound: 'К сожалению, Ваше авто не найдено. Выберите параметры авто и рассчитайте рыночную стоимость',
        year: 'Год выпуска',
        fuelType: 'Вид топлива',
        region: 'Область',
        city: 'Город',
        engine: 'Объем двигателя, л',
        trans: 'Трансмиссия',
        mech: 'Механика',
        distance: 'Пробег, тыс. км',
        number: 'Номер авто',
        back: 'вернуться назад',
        continue: 'продолжить',
        minPrice: 'Мин. цена КАСКО',
        year2: 'год',
        price: 'тыс',
        cashback: 'кешбэк',
        market: 'Средняя стоимость авто на рынке',
        clientPrice: 'Стоимость авто',
        selectCar: 'Выберите авто',
        selectModel: 'Выберите модель',
        selectTitle: 'Не выбрано',
        selectNumber: 'Не указано',
        age1: 'Мин. возраст водителя',
        dreiversCount: 'Кол-во водителей',
        driver1: 'водитель',
        driver2: 'водителя',
        without: 'Неограниченно',
        age2: 'Больше 30',
        // age2: 'Мин. возраст - 18 лет, макс. возраст - 99 лет',
        // age3: '18 лет',
        exp1: 'Мин. стаж водителя',
        exp2: 'Больше 10',
        // exp2: 'Мин. стаж - 1 год, макс. стаж - 99 лет',
        // exp3: '1 год',
        taxi: 'Такси',
        yes: 'Да',
        no: 'Нет',
        credit: 'Авто в кредите у банка?',
        find: 'подобрать полис',
        noPrice: 'К сожалению, мы не нашли стоимость для указанного авто',
        isEmptyFields: 'Укажите все данные авто, чтобы узнать его стоимость',
        agree: 'Указать свою цену',
        minPriceCar: 'Мин. цена - 1 $, макс. цена - 10 000 000$',
        minNumberLength: 'Мин. кол-во символов - 8',
        minYear: 'Макс. возраст машины - 11 лет',
        errTitle: 'К сожалению, сервис сейчас не доступен',
        errText: 'Попробуйте, пожалуйста, позже',
      },
      ua: {
        title1: "Визначте ринкову ціну",
        title2: "автомобіля по держ. номеру",
        titleTxt: 'Для зареєстрованих в Україні',
        needed: "Обов'язкове поле",
        btn1: 'оцінити вартість',
        forget: "Не пам'ятаю держ. номер",
        title3: 'Розрахунок вартості КАСКО',
        notFound: 'На жаль, Ваше авто не знайдено. Оберіть параметри авто і розрахуйте ринкову вартість',
        year: 'Рік випуску',
        fuelType: 'Вид пального',
        region: 'Область',
        city: 'Місто',
        engine: "Об'єм двигуна, л",
        trans: 'Трансмісія',
        mech: 'Механіка',
        distance: 'Пробіг, тис. км',
        number: 'Номер авто',
        back: 'Повернутися назад',
        continue: 'продовжити',
        minPrice: 'Мін. ціна КАСКО',
        year2: 'рік',
        price: 'тис',
        cashback: 'кешбек',
        market: 'Середня вартість авто на ринку',
        clientPrice: 'Вартість авто',
        selectCar: 'Виберіть авто',
        selectModel: 'Виберіть модель',
        selectTitle: 'Не вибрано',
        selectNumber: 'Не вказано',
        age1: 'Мін. вік водія',
        dreiversCount: 'Кількість водіїв',
        driver1: 'водій',
        driver2: 'водія',
        without: 'Необмежено',
        age2: 'Більше 30',
        // age2: 'Мін. вік - 18 років, макс. вік - 99 років',
        // age3: '18 років',
        exp1: 'Мін. стаж водія',
        exp2: 'Більше 10',
        // exp2: 'Мін. стаж - 1 рік, макс. стаж - 99 років',
        // exp3: '1 рік',
        taxi: 'Таксі',
        yes: 'Так',
        no: 'Ні',
        credit: 'Авто в кредит у банку?',
        find: 'підібрати поліс',
        noPrice: 'На жаль,  ми не знайшли вартість для вказаного авто',
        isEmptyFields: 'Вкажіть всі дані авто щоб дізнатися його вартість',
        agree: 'Вказати свою ціну',
        minPriceCar: 'Мін. ціна - 1 $, макс. ціна - 10 000 000 $',
        minNumberLength: 'Мін. кількість символів - 8',
        minYear: 'Макс. вік машини - 11 років',
        errTitle: 'На жаль, сервіс зараз недоступний',
        errText: 'Спробуйте, будь ласка, пізніше',
      },
    });
    strings.setLanguage(this.props.locale);

    if (autoMarks.error || autoFuels.error || autoTransmissions.error || regions.error) {
      return (
        <div className="error-boundry">
          <ErrorIndicator
            title={strings.errTitle}
            text={strings.errText}
          />
        </div>
      )
    }

    // список марок авто
    const carsOptions = autoMarks.autoMarks.map((item) => {
      return <option value={item.value} key={item.value}>{item.name}</option>
    });

    // список моделей авто
    const modelsOptions = autoModels.autoModels.map((item, id) => (
      <option value={item.value} key={id}>{item.name}</option>
    ));

    // список годов авто
    const yearsOptions = this.state.years.map((item, id) => (
      <option value={item} key={id}>{item}</option>
    ));

    // список топлива авто
    const fuelsOptions = autoFuels.autoFuels.map((item) => {
      return <option value={item.value} key={item.value}>{item.name}</option>
    });

    // список трансмиссии авто
    const transmissionsOptions = autoTransmissions.autoTransmissions.map((item) => {
      return <option value={item.value} key={item.value}>{item.name}</option>
    });

    // список регионов
    const regionsOptions = regions.regions.map((item) => {
      return <option value={item.value} key={item.value}>{item.name}</option>
    });

    // список городов
    const citiesOptions = cities.cities.map((item) => {
      return <option value={item.value} key={item.value}>{item.name}</option>
    });

    // список возраста
    const agesOptions = ["18-25", "26-30"].map((item) => {
      return <option value={item} key={item}>{item}</option>
    });

    // список опыта
    const expOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
      return <option value={item} key={item}>{item}</option>
    });

    return (
      <section id="kasco">
        <div className="container">
          {this.state.step === 2 && (cities.error || autoModels.error) && <ErrorBanner locale={this.props.locale} />}
          { this.state.step === 1 && (
            <SearchCarNumber
              strings={strings}
              step={this.state.step}
              findByNumber={this.findByNumber}
              focused={this.state.focused}
              focusInput={this.focusInput}
              blurInput={this.blurInput}
              searchNumber={this.state.searchNumber}
              handleChange={this.handleChange}
              loading={this.state.loading}
              scrollToForm={this.scrollToForm}
              ref={this.props.getSearchCarNumberRef}
              getCarNumberFormRef={this.getCarNumberFormRef}
              addToDataLayer={this.props.addToDataLayer}
            />
          ) }
          { this.state.step === 2 && (
            <CarForm
              strings={strings}
              step={this.state.step}
              sendCarInfo={this.sendCarInfo}
              hasError={this.state.hasError}
              carsData={this.state.carsData}
              carsOptions={carsOptions}
              handleInputs={this.handleInputs}
              modelsOptions={modelsOptions}
              yearsOptions={yearsOptions}
              fuelsOptions={fuelsOptions}
              transmissionsOptions={transmissionsOptions}
              regionsOptions={regionsOptions}
              citiesOptions={citiesOptions}
              prevStep={this.prevStep}
              loading={this.state.loading}
              marketPrice={this.state.marketPrice}
              clientPrice={this.state.clientPrice}
              marketPriceUah={this.state.marketPriceUah}
              notFound={this.state.notFound}
              handleChangeCarNumber={this.handleChangeCarNumber}
              carNumber={this.state.carsData.car_number}
              isLoadingMarketPrice={this.state.isLoadingMarketPrice}
              handleChangeMarketPrice={this.handleChangeMarketPrice}
              carPriceChecked={this.state.carPriceChecked}
              checkBoxChange={this.checkBoxChange}
              addToDataLayer={this.props.addToDataLayer}
            />
          ) }
          { this.state.step === 3 && (
            <DriverForm
              strings={strings}
              step={this.state.step}
              prevStep={this.prevStep}
              loading={this.state.loading}
              marketPrice={this.state.marketPrice}
              marketPriceUah={this.state.marketPriceUah}
              sendAdditionalInfo={this.sendAdditionalInfo}
              setDriversCount={this.setDriversCount}
              additionalData={this.state.additionalData}
              hasError={this.state.hasError}
              handleAdditionalInputs={this.handleAdditionalInputs}
              carsData={this.state.carsData}
              clientPrice={this.state.clientPrice}
              agesOptions={agesOptions}
              expOptions={expOptions}
              addToDataLayer={this.props.addToDataLayer}
            />
          ) }

        </div>{/* /container */}
      </section>
    );
  }
}

export default withRouter(InsuranceSearchForm);
